import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

/**
 * Konfigurations-Guard.
 *
 * Die App braucht VITE_APPWRITE_ENDPOINT / _PROJECT_ID / _DATABASE_ID aus der
 * .env des Deployments. Fehlen sie (z. B. wenn der Build-Source ohne .env
 * neu geklont wurde), wuerde die App still mit "undefined" gegen die API
 * laufen und sich mit einem leeren Dashboard zeigen. Stattdessen wird hier
 * eine klare Meldung ausgegeben.
 */
const REQUIRED = [
  ['VITE_APPWRITE_ENDPOINT', import.meta.env.VITE_APPWRITE_ENDPOINT],
  ['VITE_APPWRITE_PROJECT_ID', import.meta.env.VITE_APPWRITE_PROJECT_ID],
  ['VITE_APPWRITE_DATABASE_ID', import.meta.env.VITE_APPWRITE_DATABASE_ID],
]

const missing = REQUIRED.filter(([, value]) => !value).map(([name]) => name)

const ConfigError = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#0f172a', color: '#e2e8f0', fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif' }}>
    <div style={{ maxWidth: 620, background: '#1e293b', border: '1px solid #334155', borderRadius: 16, padding: 32 }}>
      <h1 style={{ margin: '0 0 12px', fontSize: 20, color: '#f8fafc' }}>Konfiguration unvollständig</h1>
      <p style={{ lineHeight: 1.6, color: '#cbd5e1' }}>
        Der Build dieser Anwendung enthält keine Appwrite-Verbindung. Die Anwendung kann
        deshalb keine Daten laden. Betroffen sind:
      </p>
      <ul style={{ color: '#fca5a5', lineHeight: 1.9 }}>
        {missing.map((name) => <li key={name}><code>{name}</code></li>)}
      </ul>
      <p style={{ lineHeight: 1.6, color: '#cbd5e1' }}>
        Diese Werte kommen aus der <code>.env</code> im Build-Verzeichnis des Deployments
        (Dokploy → ChargeNest-Management App → Environment). Nach dem Eintragen genügt ein
        erneutes Deployment.
      </p>
    </div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {missing.length > 0 ? <ConfigError /> : <App />}
  </React.StrictMode>,
)
